// ---------------- logos ------------------
import logo from "../assets/logos/black_logo.png";
import Forbes_logo from "../assets/logos/Forbes_logo.png";
import NBC_logo from "../assets/logos/NBC_logo.png";
import fox_logo from "../assets/logos/fox_logo.png";
import wsj_logo from "../assets/logos/wsj_logo.png";
import yahoo_logo from "../assets/logos/yahoo_logo.png";
import The_New_York_Times_logo from "../assets/logos/The_New_York_Times_logo.png";
import male from "../assets/logos/male.png";
import female from "../assets/logos/female.png";

import american from "../assets/logos/american.svg";
import master from "../assets/logos/master.svg";
import jcb from "../assets/logos/jcb.svg";
import visa from "../assets/logos/visa.svg";
import treat_med from "../assets/logos/med.png";
import treat_lock from "../assets/logos/lock.png";
import treat_doctor from "../assets/logos/doctor.png";
import treat_hand from "../assets/logos/hand.png";
import treat_weight from "../assets/logos/weight.png";
import levelup_med_img from "../assets/logos/levelup_med_img.png";

// ---------------- images ------------------

import product_icon from "../assets/logos/product_icon.png";
import delivery_truck from "../assets/logos/delivery-truck.png";
import stethoscope from "../assets/logos/stethoscope-medical-tool.png";
import metabolism from "../assets/logos/metabolism.png";
import bottel_img from "../assets/logos/bottel_img.png";


export default {
  // ---------------- logos ------------------
  logo,
  Forbes_logo,
  NBC_logo,
  fox_logo,
  wsj_logo,
  yahoo_logo,
  The_New_York_Times_logo,

  visa,
  master,
  jcb,
  american,

  treat_doctor,
  treat_hand,
  treat_lock,
  treat_med,
  treat_weight,
  levelup_med_img,
  bottel_img,

  // ---------------- images ------------------

  product_icon,
  delivery_truck,
  stethoscope,
  metabolism,
};
